import { Location } from '../models/Context'

/**
 * @param location
 */
export const hasCodeInUrl = (location: Location): boolean => {
  const searchParams = new URLSearchParams(location.search)
  const hashParams = new URLSearchParams(location.hash.replace('#', '?'))

  return Boolean(
    searchParams.get('signin-oidc') ||
    searchParams.get('code') ||
    searchParams.get('id_token') ||
    searchParams.get('session_state') ||
    hashParams.get('code') ||
    hashParams.get('id_token') ||
    hashParams.get('session_state')
  )
}
